import React from 'react';
import bilbylogo from '../assets/logo.svg';

interface LogoProps {
  isCompact?: boolean;
}

const Logo: React.FC<LogoProps> = ({ isCompact = false }) => {
  // Generate unique IDs for masks
  const maskId1 = React.useId();
  const maskId2 = React.useId();

  if (isCompact) {
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 114 124"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="transition-all duration-300"
      >
        <rect width="51" height="124" rx="25.5" fill="#EF12DD" />
        <rect x="63" width="51" height="124" rx="25.5" fill="#00CCFF" />
        <defs>
          <mask id={maskId1} maskUnits="userSpaceOnUse" x="63" y="0" width="51" height="124">
            <rect x="63" width="51" height="124" rx="25.5" fill="#2F5FC5" />
          </mask>
          <mask id={maskId2} maskUnits="userSpaceOnUse" x="26" y="32" width="60" height="60">
            <circle cx="56" cy="62" r="30" fill="#0053CD" />
          </mask>
        </defs>
        <g mask={`url(#${maskId1})`}>
          <circle cx="56" cy="62" r="30" fill="#226DDC" />
        </g>
        <g mask={`url(#${maskId2})`}>
          <rect y="-4" width="51" height="124" rx="25.5" fill="#8A028F" />
        </g>
      </svg>
    );
  }

  return <img src={bilbylogo} alt="Bilby Logo" style={{ width: '95px', height: '32px' }} />;
};

export default Logo;
